module.exports = __webpack_public_path__ + "img/semiRing6.96948f3d.svg";